export const leave = {
  explain: {
    working_days: "{count} iş günü düşülecek.",
    working_days_half: "{count} iş günü düşülecek (yarım günler dahil).",
    hours: "{count} saat düşülecek.",
    weekend_skipped_one: "{count} hafta tatili günü sayılmadı.",
    weekend_skipped_other: "{count} hafta tatili günü sayılmadı.",
    short_day_one: "Yarım çalışılan gün (çalışma düzeninize göre) 0,5 gün sayıldı.",
    short_day_other: "{count} yarım çalışılan gün (çalışma düzeninize göre) 0,5'er gün sayıldı.",
    holiday_skipped: "{name} ({date}) resmî tatil olduğu için sayılmadı.",
    half_holiday: "{name} ({date}) yarım gün tatil; yalnızca sabah yarısı sayıldı.",
    calendar_days: "Bu izin türünde takvim günleri sayılır: {count} gün.",
    no_balance_tracking: "Bu izin türü bakiyeden düşmez.",
    return_date: "İşe dönüş: {date}.",
  },
  warnings: {
    negative_balance: "Bu talepten sonra bakiyeniz eksiye düşecek ({after}). Şirket politikası buna izin veriyor.",
    team_overlap_one: "Ekibinizden {count} kişi bu tarihlerde izinli.",
    team_overlap_other: "Ekibinizden {count} kişi bu tarihlerde izinli.",
    requires_document: "Bu izin türü için belge gerekiyor: {hint}",
    past_dates: "Geçmiş tarihli bir talep oluşturuyorsunuz.",
    max_per_request: "Bu izin türünde tek seferde en fazla {max} kullanılabilir.",
    no_approver: "Yöneticiniz tanımlı değil; talep İK ekibine gidecek.",
  },
  approver: {
    manager: "Yönetici",
    hr: "İK",
    hr_pool: "İK ekibi",
  },
  waiting: {
    person: "{name} yanıtını bekliyor",
    pool: "{label} yanıtını bekliyor",
  },
  timeline: {
    submitted: "Talep gönderildi",
    submitted_on_behalf: "Talep {name} tarafından adınıza oluşturuldu",
    approved_step: "{name} onayladı",
    approved_step_delegate: "{name}, {forName} adına onayladı",
    rejected: "{name} reddetti",
    returned: "{name} düzeltme için geri gönderdi",
    resubmitted: "Düzeltilip yeniden gönderildi",
    cancelled: "Talep iptal edildi",
    corrected: "{name} tarihleri düzeltti",
    approved: "Talep onaylandı",
    rerouted: "Onaycı değişti: artık {name} bekleniyor",
  },
  ledger: {
    opening: "Açılış bakiyesi",
    accrual: "Yıllık hak ediş",
    usage: "Kullanım",
    reversal: "İptal iadesi",
    adjustment: "Düzeltme",
    carryover: "Devir",
    expiry: "Süresi dolan",
    payout: "Ücrete dönüştürülen",
  },
};
